export default __webpack_public_path__ + "static/media/webclock.22aa3b7a.png";